import { createLazyReactDirective } from '../../shell/createLazyReactDirective';

export default createLazyReactDirective(
  async () => (await import('./LeadsList')).LeadsList,
  'leadsList',
  {
    leads: '=',
    leadsLoading: '=',
    totalLeads: '=',
    fetchMoreLeads: '=',
    fullTextQuery: '=',
    query: '=',
    customFields: '=',
    sorting: '=',
    extraColumns: '=',
    onChangeExtraColumns: '=',
    onChangeSorting: '=',
    routeParams: '=',
    embeddedIntegrationName: '=?',
  },
);
